/* eslint-disable import/no-anonymous-default-export */
import request from "../request";

const getUsers = () => request.get("users");
const addUser = (payload) => request.post("users", payload);
const updateUser = (payload, userId) => request.put(`users/${userId}`, payload);
const deleteUser = (userId) => request.delete(`users/${userId}`);
const getUserInfo = () => request.get("users/me");

const getRoles = () => request.get("roles");

// Add company service methods
const getCompanies = (query) => request.get(`company?${query || ""}`);
const getCompany = (id) => request.get(`company/${id}`);
const addCompany = (payload) => request.post("company", payload);
const updateCompany = (id, payload) => request.put(`company/${id}`, payload);
const deleteCompany = (id) => request.delete(`company/${id}`);

const logout = () => request.post("/logout");

export default {
	getUsers,
	addUser,
	updateUser,
	deleteUser,
	getUserInfo,

	getRoles,

	getCompanies,
	getCompany,
	addCompany,
	updateCompany,
	deleteCompany,

	logout,
};
